export { type SentenceWord, sentenceWordTable } from "#sentence-word-table";
